import React from "react";


/**
 * * .marker-info-container
 */
export const markerInfoCard = {
    background : "transparent",
    overflow: "hidden",
    color: '#d6d6d6',
    width: "10%%",
    marginTop: '0em',
    boxShadow: 'none'
}

export const closeButton={
    /*float: 'right',*/
    left: 'calc(100% - 34px)',
    top: '0',
    color: "#FFFFFF"
}

export const infoWindowImg={
    height: 'auto',
    maxWidth: '98%',
    marginLeft: '1%',
    verticalAlign: 'middle',
}

export const markerInfoCardBody ={
    paddingRight: '1rem',
    paddingLeft: '1rem',
    paddingBottom: '1rem',
}

export const pStyle={
    fontSize: ' 0.875rem',
    lineHeight: ' 1.5',
    marginBottom: '1.25rem',
    fontWeight: '400',
    color: "#FFFFFF",
}

export const infoWindowCarousel={
    height: 'auto',
    maxWidth: '100%',
    verticalAlign: 'middle',
    marginTop: "-1rem",
    padding: "1rem",
    backgroundColor: '#d6d6d6',
    color: '#333333',
    fontSize:'16px',
    fontWeight:600
}
